import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
// -*- MODE: JSX;-*-
import PureRenderMixin from './external-adapters/pureRenderMixinAdapter.js';

// consumers expect "dc.common.LoadingEllipsis" to be a traditional
export const LoadingEllipsis = createReactClass({
    propTypes: {
        className: PropTypes.string,
        useShield: PropTypes.bool,
    },

    mixins: [PureRenderMixin],

    getDefaultProps: function () {
        return {
            className: '',
            useShield: false,
        };
    },

    showShield: function () {
        if (this.props.useShield) {
            return (
                <div className={'shield'}></div>
            );
        }
        return null;
    },

    render: function () {
        return (
            <div>
                {this.showShield()}
                <div className={'loader ' + this.props.className} role="alert" aria-label="loading">
                    <div className="dot one"></div>
                    <div className="dot two"></div>
                    <div className="dot three"></div>
                </div>
            </div>
        );
    },
});
